import React from "react";
import { TabsContent } from "../ui/tabs";
import ScrapePipelineHealthWidget from "./ScrapePipelineHealthWidget";
import LogExplorer from "./LogExplorer";
import JobHealthBoard from "./JobHealthBoard";
import AnomalyReport from "./AnomalyReport";
import FirecrawlBudgetPanel from "./FirecrawlBudgetPanel";
import AdminAuditCard from "./AdminAuditCard";
import HealthHistoryCard from "./HealthHistoryCard";

export default function SystemTab({ dm, stats }) {
  return (
    <TabsContent value="system">
      {/* iter108 Fase 2 — real jobs board + live integration checks
          (replaces the old hardcoded "System Health" card) */}
      <JobHealthBoard dm={dm} />

      {/* iter109 Fase 3 — deterministic anomaly rules over the last 24h */}
      <div className="mt-6">
        <AnomalyReport dm={dm} />
      </div>

      {/* iter136 — Firecrawl throttle + boost controls with live state */}
      <div className="mt-6">
        <FirecrawlBudgetPanel dm={dm} />
      </div>

      {/* iter145 — sensitive admin actions audit trail */}
      <AdminAuditCard dm={dm} />

      {/* iter101 — per-provider 30-day uptime timeline */}
      <HealthHistoryCard dm={dm} />

      <div className={`mt-6 rounded-2xl p-6 ${dm ? "bg-[#1a2122]" : "bg-white"}`} style={{ boxShadow: "0 0 0 1px rgba(186,201,204,0.1), 0 4px 24px rgba(25,28,29,0.04)" }}>
        <h3 className={`editorial-heading text-xl font-medium mb-5 ${dm ? "text-slate-100" : "text-[#191c1d]"}`}>Activity Log</h3>
        <div className="space-y-1">
          {(stats?.activity || []).length === 0 ? (
            <p className={`text-sm text-center py-6 ${dm ? "text-slate-600" : "text-[#6b7a7d]"}`}>No recent activity</p>
          ) : (stats?.activity || []).map((item, i) => (
            <div
              key={`${item.timestamp ?? i}-${item.action ?? i}`}
              className={`flex gap-3 py-2.5 border-b ${dm ? "border-white/4" : "border-black/4"} last:border-0`}>
              <span className={`category-tag flex-shrink-0 pt-0.5 w-28 ${dm ? "text-slate-600" : "text-[#bac9cc]"}`}>{new Date(item.timestamp).toLocaleTimeString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
              <div>
                <p className={`text-sm font-medium ${dm ? "text-slate-200" : "text-[#191c1d]"}`}>{item.action}</p>
                <p className={`category-tag mt-0.5 ${item.type === "success" ? (dm ? "text-emerald-500" : "text-emerald-600") : item.type === "warning" ? (dm ? "text-amber-500" : "text-amber-600") : (dm ? "text-slate-500" : "text-[#6b7a7d]")}`}>{item.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Full-width Scrape Pipeline Health widget — added 30-jun-2026 (iter 69)
          so admin can spot per-stage perf regressions before they cause
          another 38h feed freeze. */}
      <div className="mt-6">
        <ScrapePipelineHealthWidget dm={dm} />
      </div>

      {/* iter107 Fase 1 — production log explorer + segmented download */}
      <div className="mt-6">
        <LogExplorer dm={dm} />
      </div>
    </TabsContent>
  );
}
